<div class="modal-content  d-none d-md-block rounded" style="height: 90vh !important; background: url(./assets/img/nubes.svg) #0B4595  !important ;">
    <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
        <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
    </div> -->
    <!-- <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
        <mat-icon >reply</mat-icon>
    </button> -->
    <div  class="card bg-body mat-elevation-z8  rounded " style="width: 30rem; position: absolute; top: 25%; left: 35%; z-index: 2;">
        
        <div class="card-body">
            <div  class="p-2 rounded d-flex justify-content-center gap-3 bg-body text-center mb-2" style="color: #F1443D;">
                <span  #minutes class="fw-bold fs-2"></span>
                <span   class=" fs-2">:</span>
                <span  #seconds class="fw-bold fs-2"></span>
            </div>
            <div class="text-center mb-2">
                <h5 class="card-subtitle text-muted">{{text_t | uppercase}} </h5>
            </div>
          <div class="text-center mb-3 fw-bold fs-5">
            <p class="card-text">{{cont_test}}.  {{test_final | uppercase}} </p>
          </div>
          <div *ngIf="param_2 === param" class="d-flex justify-content-center gap-2">
            <button *ngFor="let i of text_f" [disabled]="!b_rp" (click)="rpctTest(i)"  mat-raised-button color="primary"  class="text-white">{{i | uppercase}}</button>
          </div>
          <div *ngIf="param_2 !== param && param_3 === false" class="d-grid justify-content-center gap-2">
            <button *ngFor="let i of text_f" [disabled]="!b_rp" (click)="rpctTest(i)"  mat-raised-button color="primary"  class="text-white ">{{i | uppercase}}</button>
          </div>
          <div *ngIf="param_2 !== param && param_3 === true" class="d-flex justify-content-center gap-2">
            <button *ngFor="let i of text_f" [disabled]="!b_rp" (click)="rpctTest(i)"  mat-raised-button color="primary"  class="text-white ">{{i | uppercase}}</button>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <button *ngIf="!test_f" [disabled]="!b_sig"  mat-raised-button (click)="cambiarTest()" color="primary"  class="text-white ">Siguiente</button>
            <button *ngIf="test_f" [disabled]="!b_sig"  mat-raised-button (click)="modalrespuesta()" color="warn"  class="text-white  ">Finalizar</button>
        </div>
    </div>
    <div class="modal-body">
        <div class="container-fluid" style="padding: 1%">
            <div class="row" style="margin-top: 5%;">
                <div class="col-3"></div>
                <div class="col-3 px-1 pt-5">
                </div>
                <div class="col-3 container">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <img src="./assets/img/Logo_speakup.png" width="100px" class="mb-3">
                        </div>
                    </div>
                </div>
                <div class="col-3"></div>
            </div>
        </div>
    </div>
</div>
